import React, { useState } from 'react';
import axios from 'axios';

const ExcelDownloadPage = () => {
    const currentMonth = new Date().getMonth() + 1;
    const currentYear = new Date().getFullYear();

    const [month, setMonth] = useState(currentMonth);
    const [year, setYear] = useState(currentYear);
    const [showReports, setShowReports] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const API_BASE = process.env.REACT_APP_URL;

    const reports = [
        { id: 'fps-status', name: 'FPS Status', filename: 'FPS_Status' },
        { id: 'distribution-percent', name: 'Distribution %', filename: 'Distribution_Per' },
        { id: 'fps-portability', name: 'FPS Wise Portability', filename: 'FPS_Wise_Portability' },
        { id: 'key-register', name: 'Key Register', filename: 'FPS_Key_Register' },
        { id: 'detailed-trans', name: 'FPS Detailed Transactions', filename: 'FPS_Detailed_Trans' },
        { id: 'fps-sales', name: 'FPS Wise Sales', filename: 'FPS_Wise_Sales' },
        { id: 'fps-stock', name: 'FPS Wise Stock', filename: 'FPS_Wise_Stock' },
        { id: 'fps-cb',               name: 'FPS Wise Closing Balance',    filename: 'FPS_Wise_CBs' },   
    ];

    const handleSubmit = () => {
        setShowReports(true);
        setError('');
    };

    const downloadReport = async (report) => {
        setLoading(true);
        setError('');

        try {
            const response = await axios.get(`${API_BASE}/api/reports/${report.id}/download`, {
                params: { month, year },
                responseType: 'blob',
            });

            const blob = new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${report.filename}_${String(month).padStart(2, '0')}_${year}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error(err);
            setError(`Failed to download ${report.name}`);
        } finally {
            setLoading(false);
        }
    };

    const getMonthName = (m) => {
        return new Date(2000, m - 1, 1).toLocaleString('default', { month: 'long' });
    };

    return (
        <div style={{ fontFamily: 'Arial, sans-serif', padding: '20px' }}>
            {/* Header */}
            {/* <div style={{ 
        backgroundColor: '#000080', 
        color: 'white', 
        padding: '10px', 
        textAlign: 'center',
        fontSize: '18px',
        fontWeight: 'bold'
      }}>
        Excel Download
      </div> */}

            <div >
                <table width="50%" align='center'>
                    <tbody>
                        <tr className='tableheader'><th colspan="4">Excel Download</th></tr>
                        <tr>
                            <td>Month</td>
                            <td>
                                <select
                                    value={month}
                                    onChange={(e) => setMonth(Number(e.target.value))}
                                    
                                >
                                    {Array.from({ length: 12 }, (_, i) => i + 1).map(m => (
                                        <option key={m} value={m}>
                                            {getMonthName(m)}
                                        </option>
                                    ))}
                                </select>
                            </td>
                            <td>Year</td>
                            <td>
                                <select
                                    value={year}
                                    onChange={(e) => setYear(Number(e.target.value))}
                                    
                                >
                                    {[currentYear - 3, currentYear - 2, currentYear - 1, currentYear, currentYear + 1].map(y => (
                                        <option key={y} value={y}>{y}</option>
                                    ))}
                                </select>
                            </td>
                        </tr>
                        <tr >
                            <td colSpan={4} align='center' >
                                <button
                                    onClick={handleSubmit} className="button button2"

                                >
                                    Submit
                                </button>
                                
                                <button className="button button2"
                                    onClick={() => window.history.back()}

                                >
                                    Back
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <br/><br/><br/>
            </div>

            {/* Reports List */}
            {showReports && (
                <div style={{ maxWidth: '900px', margin: '0 auto' }}>
                   
                    <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #ccc' }}>
                        <thead>
                            <tr className='tableheader'>
                              <th colspan="2">  Excel Downloads for {getMonthName(month)}'{year}</th>
                            </tr>
                            <tr className='tableheader'>
                                <th rowSpan={2}>Sl.No</th>
                                <th >Report Name</th>
                            </tr>
                        </thead>
                        <tbody>
                            {reports.map((report, index) => (
                                <tr key={report.id} style={{ backgroundColor: index % 2 === 0 ? '#f9f9f9' : 'white' }}>
                                    <td >
                                        {index + 1}
                                    </td>
                                   
                                 <td style={{ padding: '12px', border: '1px solid #ccc' }}>
                                        <span
                                            onClick={() => downloadReport(report)}
                                            style={{
                                                textDecoration: 'underline',
                                                color: 'blue',
                                                cursor: loading ? 'not-allowed' : 'pointer',
                                                opacity: loading ? 0.5 : 1
                                            }}
                                        >
                                            {report.name}
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    {error && (
                        <div style={{ color: 'red', textAlign: 'center', marginTop: '15px' }}>
                            {error}
                        </div>
                    )}
                </div>
            )}

            {loading && (
                <div style={{ textAlign: 'center', marginTop: '20px', color: '#0066cc' }}>
                    Downloading...
                </div>
            )}
        </div>
    );
};

export default ExcelDownloadPage;